<script setup>
// Define props to control visibility
import { onMounted, ref } from 'vue'
import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'
import BaseModal from '@/components/Alerts/BaseModal.vue'
import { ModalVerticalSize } from '@/components/Alerts/ModalSize.js'
import { Tenants } from '@/models/tenants/Tenants'

defineProps({
	isOpen: {
		type: Boolean,
		required: true
	}
});
const tenant = ref(null)
const showTerms = ref(true);
const showPrivacy = ref(false);

// Define emits to communicate back to the parent
const emit = defineEmits(['close']);

onMounted(() => {
	tenant.value = Tenants.getTenant()
})

</script>

<template>
	<BaseModal :show="isOpen" :vertical-size="ModalVerticalSize.Full" padding-classes="p-12">
		<div class="flex flex-col bg-neutral w-203 h-full">
			<div class="flex flex-row justify-between items-center bg-neutral-light p-2 text-lg rounded-t-md">
				<h2 class="font-bold ">Terms and Conditions</h2>
				<div class="cursor-pointer">
					<img v-if="showTerms" src="@/assets/images/icon/minus.svg" alt="-" title="Collapse" @click.prevent="showPrivacy = true; showTerms=false;">
					<img v-else src="@/assets/images/icon/plus.svg" alt="+" title="Expand" @click.prevent="showPrivacy = false; showTerms=true;">
				</div>
			</div>

			<div v-show="showTerms" class="flex-1 overflow-y-auto mb-6 border border-solid border-grayscale border-opacity-20 p-3">
				<iframe class="w-full h-full" :src="tenant.termsAndPrivacy.terms" />
			</div>

			<div class="flex flex-row justify-between items-center bg-neutral-light p-2 text-lg rounded-t-md mt-2">
				<h2 class="font-bold ">Privacy</h2>
				<div class="cursor-pointer">
					<img v-if="showPrivacy" src="@/assets/images/icon/minus.svg" alt="-" title="Collapse" @click.prevent="showPrivacy = false; showTerms=true;">
					<img v-else src="@/assets/images/icon/plus.svg" alt="+" title="Expand" @click.prevent="showPrivacy = true; showTerms=false;">
				</div>
			</div>

			<div v-show="showPrivacy" class="flex-1 overflow-y-auto mb-6 border border-solid border-grayscale border-opacity-20 p-3">
				<iframe class="w-full h-full" :src="tenant.termsAndPrivacy.privacy" />
			</div>

			<div class="flex flex-row justify-end mt-4">
				<SubmitButton label="Close" size="small" @click="emit('close')"/>
			</div>
		</div>
	</BaseModal>
</template>